import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { images } from '../../constants';

// Single 1.1s sweep (was two overlapping 2.0s / 2.5s timelines that both
// fired onComplete). App also waits for the hero portrait to finish loading
// while this plays, so Home never mounts with an empty image slot.
const Splash = ({ onComplete }) => (
  <motion.div
    className="fixed inset-0 z-[999] flex items-center justify-center bg-[#0a0907]"
    exit={{ opacity: 0 }}
    transition={{ duration: 0.35, ease: 'easeOut' }}
  >
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(50%_50%_at_50%_45%,rgba(244,63,94,0.10),transparent_70%)]" />
    <div className="relative flex flex-col items-center justify-center px-4">
      <img
        src={images.collinsburnerWebp}
        alt="Collins Musoko"
        width={900}
        height={600}
        decoding="async"
        className="h-auto w-[min(60vw,22rem)] rotate-[-8deg] object-contain"
      />

      <div className="mt-6 h-0.5 w-[min(70vw,16rem)] overflow-hidden rounded-full bg-white/10">
        <motion.div
          className="h-full rounded-full bg-gradient-to-r from-rose-500 to-orange-400"
          initial={{ width: '0%' }}
          animate={{ width: '100%' }}
          transition={{ duration: 1.1, ease: [0.65, 0, 0.35, 1] }}
          onAnimationComplete={onComplete}
        />
      </div>
    </div>
  </motion.div>
);

Splash.propTypes = {
  onComplete: PropTypes.func.isRequired,
};

export default Splash;
